import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "./i18n/I18nContext";
import { AuthProvider } from "./auth/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Enroll from "./pages/Enroll";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentInfo from "./pages/PaymentInfo";
import Services from "./pages/Services";
import ServicesSuccess from "./pages/ServicesSuccess";
import Competition from "./pages/Competition";
import StudentDashboard from "./pages/StudentDashboard";
import TrainerDashboard from "./pages/TrainerDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import EnrollAdvanced from "./pages/EnrollAdvanced";
import CourseFomasyonWeb from "./pages/CourseFomasyonWeb";
import CourseProgramationAI from "./pages/CourseProgramationAI";
import CohortInfo from "./pages/CohortInfo";

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-right" richColors closeButton />
            <FloatingWhatsApp />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/cohort-info" element={<CohortInfo />} />
              <Route path="/payment-info" element={<PaymentInfo />} />
              <Route path="/services" element={<Services />} />
              <Route path="/competition" element={<Competition />} />
              <Route path="/competition-2026" element={<Competition />} />
              {/* Public course presentation pages — anonymous visitors can view content;
                  enrollment CTAs lead to /enroll & /enroll-advanced (also public). */}
              <Route path="/fomasyon-web" element={<CourseFomasyonWeb />} />
              <Route path="/programation-ai" element={<CourseProgramationAI />} />
              <Route path="/services/success" element={
                <ProtectedRoute><ServicesSuccess /></ProtectedRoute>
              } />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              {/* PUBLIC presentation pages — anyone can view the curriculum & pricing.
                  Auth is only required at the moment of payment submission (handled inside the page). */}
              <Route path="/enroll" element={<Enroll />} />
              <Route path="/enroll-advanced" element={<EnrollAdvanced />} />
              <Route path="/payment/success" element={
                <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
              } />
              <Route path="/student" element={
                <ProtectedRoute roles={["student", "member", "admin"]}><StudentDashboard /></ProtectedRoute>
              } />
              <Route path="/trainer" element={
                <ProtectedRoute roles={["trainer", "admin"]}><TrainerDashboard /></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>
              } />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
